/**
 * Hamburger menu title link behavior:
 * When hamburger_menu_title_link is ON: title navigates, arrow toggles submenu.
 * Stop propagation on link click so details doesn't toggle.
 */
(function () {
  const init = (container) => {
    const headerDrawer = container
      ? container.querySelector('header-drawer[data-hamburger-title-link="true"]')
      : document.querySelector('header-drawer[data-hamburger-title-link="true"]');

    if (!headerDrawer || headerDrawer.dataset.menuTitleLinkInit) return;
    headerDrawer.dataset.menuTitleLinkInit = '1';

    headerDrawer.addEventListener('click', (e) => {
      const link = e.target.closest('details summary .menu-drawer__menu-link[href]');
      if (link) e.stopPropagation();
    });
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
